import React from 'react';
import LogoImage from '../logo.png'
export const logo = <img alt="logo" src={LogoImage} />